export default "__VITE_ASSET__Bbf4i8q2__"